<template>
    <div>
        <b-row>
            <b-col>
                {{item.articleDetails.primaryDescription || item.articleDetails.secondaryDescription}}
            </b-col>
            <b-col cols="12" sm="auto">
                {{item.amount}} {{article.quantityUnit}}
            </b-col>
            <b-col cols="3" class="text-left">
                {{item.totalCalculatedPerUnit | currency($currencyFormatting[articlePrice.currency])}} /
                {{article.quantityUnit}}
                <br>
                <span v-if="isSamplePrice">
                    <small>sample price</small>
                </span>
                <span v-else>
                    <small>bulk price</small>
                </span>
            </b-col>
            <b-col cols="3" class="text-right">
                {{item.totalCalculated | currency($currencyFormatting[articlePrice.currency])}}
<!--                <br><span class="alert-square font-sm p-1" v-if="isDiscountOnStockActive">20%</span>-->
            </b-col>
        </b-row>
        <b-row v-if="item.requestedAmountState === 'RESERVED'" >
            <b-col>
                <small class="text-danger" >
                    {{ $t("warning_amount_reserved") }}
                </small>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <hr class="full"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>


    import ArticleBase from "../Article/ArticleBase";

    export default {
        name: 'checkout-cart-item',
        extends: ArticleBase,
        props: ['item'],
        methods: {
            fetchArticleDetails() {
                return this.item.articleDetails;
            }
        },
        computed: {
            article() {
                return this.item.articleDetails;
            },
            articleDetails() {
                return this.item.articleDetails;
            },
            amount:function() {
                return this.item.amount;
            },
            category: function () {
                return this.item.category;
            },
            articlePrice:function() {
                return this.item.articlePrice;
            },
            thumbnail: function () {
                return this.item.articleDetails ? this.item.articleDetails.articleImageList.find(i => i.colorId === 0 && i.sizeId === 0) : null;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

</style>
